import { EActivityCategories } from '@/domain/Activities.domain';
import { categoryImages } from '@/ui/components/AttractionsContent/data';

const DEFAULT_ICON = EActivityCategories.WAVE;

export const findIcon = (tripName: string) => {
    const iconKey = Object.keys(categoryImages).find((key) => tripName.includes(key));

    return iconKey || DEFAULT_ICON;
};
